import { Form, Row, Col, Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import PhoneNumber from './PhoneNumbers';
import { Request } from '@group-devs/yfp7-global-modules'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function ContactDetails(props) {

    let contactAccount = props.contactAccount
    const [showUpdate, setShowUpdate] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [key, setKey] = useState(0);

    const [defaultNumber, setDefaultNumber] = useState({
        mobile: null,
        phone_number: null
    });
    const [cancelClicked, setCancelClicked] = useState(false);
    const [save, setSave] = useState(false);
    const [data, setData] = useState({ 
        firstname: null,  
        lastname: null,
        mobile: null,
        mobileNumberToSave: null,
        mobileField: null,
        phone_number: null,
        phoneNumberToSave: null,
        phoneNumberField: null,
        mobileCountryCode: null,
        phoneNumberCountryCode: null,
        mobileCountryCodeAlpha2: null,
        phoneNumberCountryCodeAlpha2: null,
    })

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setCancelClicked(true);
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    const onDoneSaving = () => {
        setSave(true)
        setShowUpdate(!showUpdate)
        setReadOnly(true)
        setSuccessMessage('Successfully updated contact details.')
        setErrorMessage(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }
    
    useEffect(() => {
        if(typeof contactAccount != 'undefined'){ 
            var countryCodeMobile = "+1" // Default code for US
            var countryCodePhone = "+1" // Default code for US
            var mobileCountryCodeAlpha2 = "us"
            var phoneNumberCountryCodeAlpha2 = "us"

            // Get the country code of mobile/phone_number and concat it to the corresponding number
            // This workaround is for the react-phone-input-2 since the number must have "country_code"
            if(contactAccount.contact.profile.country_code)
            {
                let countryCode = JSON.parse(contactAccount.contact.profile.country_code)
                countryCodeMobile = countryCode.mobile_number ? countryCode.mobile_number : null
                countryCodePhone = countryCode.phone_number ? countryCode.phone_number : null
                mobileCountryCodeAlpha2 = countryCode.mobileNumberAlpha2 ? countryCode.mobileNumberAlpha2 : null
                phoneNumberCountryCodeAlpha2 = countryCode.phoneNumberAlpha2 ? countryCode.phoneNumberAlpha2 : null
            }
            
            setData({ 
                firstname: contactAccount ? contactAccount.contact.profile.firstname : "",  
                lastname: contactAccount ? contactAccount.contact.profile.lastname : "",
                mobile: contactAccount ? contactAccount.contact.mobile_number : "000-000-000",
                mobileNumberToSave: contactAccount ? contactAccount.contact.mobile_number : "000-000-000",
                mobileField: contactAccount ? (contactAccount.contact.mobile_number ? countryCodeMobile+" "+contactAccount.contact.mobile_number : null) : "000-000-000",
                phone_number: contactAccount ? contactAccount.contact.profile.phone_number : "000-000-000",
                phoneNumberToSave: contactAccount ? contactAccount.contact.profile.phone_number : "000-000-000",
                phoneNumberField: contactAccount ? (contactAccount.contact.profile.phone_number ? countryCodePhone+" "+contactAccount.contact.profile.phone_number : null) : "000-000-000",
                mobileCountryCode: contactAccount ? (countryCodeMobile ? countryCodeMobile : null) : null,
                phoneNumberCountryCode: contactAccount ? (countryCodePhone ? countryCodePhone : null) : null,
                mobileCountryCodeAlpha2 : contactAccount ? (mobileCountryCodeAlpha2 ? mobileCountryCodeAlpha2 : null) : null,
                phoneNumberCountryCodeAlpha2 : contactAccount ? (phoneNumberCountryCodeAlpha2 ? phoneNumberCountryCodeAlpha2 : null) : null
            })

            setDefaultNumber({
                mobile: contactAccount ? (contactAccount.contact.mobile_number ? countryCodeMobile+" "+contactAccount.contact.mobile_number : null) : "000-000-000",
                phone_number: contactAccount ? (contactAccount.contact.profile.phone_number ? countryCodePhone+" "+contactAccount.contact.profile.phone_number : null) : "000-000-000",
            })

            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount, cancelClicked]);

    function handleChange(e)
    {
        var name = e.target.name;
        var value = e.target.value;
        setData({
          ...data,
          [name]: value
        });
    }

    function handleChangeNumber(value, name)
    {
        data[name] = value;
    }

    async function handleSave(e)
    {
        let cData = {
            firstname: data.firstname,
            lastname: data.lastname,
            mobile: data.mobileNumberToSave,
            phone_number: data.phoneNumberToSave,
            mobileCountryCode: data.mobileCountryCodeAlpha2,
            phoneNumberCountryCode: data.phoneNumberCountryCodeAlpha2,
        }
        let res = await request.contacts.updateContactProfile({...cData, contact_id: contactId});

        if(res.err){
            console.log('error')
        }else{
            onDoneSaving();
        }
    }

    return (
        <div className="contactDetails py-5 border-bottom">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={successMessage} errorMessage={errorMessage}/>
                    <p><strong>Contact Details</strong></p>
                    <Form>
                        <Form.Group as={Row}>
                            <Form.Label column md="3" className="text-md-right">First Name</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" className="rounded-0" value={data.firstname ? data.firstname : ""} name="firstname" onChange={handleChange} readOnly={readOnly}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column md="3" className="text-md-right">Last Name</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" className="rounded-0" value={data.lastname ? data.lastname : ""} name="lastname" onChange={handleChange} readOnly={readOnly}/>
                                <p className="mt-5 mb-0">Select the phone number you want your guide to see.</p>
                            </Col>
                        </Form.Group>
                        <PhoneNumber 
                            global={props.global} 
                            isReadonly={readOnly} 
                            data={data} 
                            handleChange={handleChangeNumber} 
                            defaultNumber={defaultNumber} 
                            cancelClicked={cancelClicked} 
                            setCancelClicked={setCancelClicked}
                            save={save}
                        />
                        <Form.Group as={Row}>
                            <Form.Label column md="3"></Form.Label>
                            <Col md="7">
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default ContactDetails
